export default {
    quote_id: 0,
    quote_number: '',
    policy_number: '',
    national_id: '',
    start_date: '',
    end_date: '',
    currency: '',
    num_of_travellers: '',
    num_of_months: '',
    travellers: [],
    total_value: 0,
    premium: 0
  }